var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270.81 320.28C265.974 323.302 260.534 324.511 255.698 324.511C250.862 324.511 245.422 323.302 240.586 320.28L0 173.39V368.639C0 410.348 33.8512 444.2 75.5608 444.2H436.439C478.149 444.2 512 410.348 512 368.639V173.39L270.81 320.28Z",
    fill: "#FF5722"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M436.439 67H75.5608C39.8961 67 9.67181 92.3884 2.41797 126.24L256.302 280.988L509.582 126.24C502.328 92.3884 472.104 67 436.439 67Z",
    fill: "#FF5722"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailManagement);
export default __webpack_public_path__ + "static/media/email-management.0d73e2bfb392a00c74b965ac7fcac83a.svg";
export { ForwardRef as ReactComponent };